var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { addAccountsFromGroupToOrganizationBulkActionType, } from '../../../../../../../backend/features/groups/shared';
import { walkOrganizations } from '../../../../../../../backend/features/permissions/shared';
import { getFilterForBulkAction } from '../../../../../../../utils';
import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { showOrganizationTreeDialog } from '../../../OrganizationsTreeDialog/OrganizationsTreeDialog';
export const handleAddToOrganization = (userState, t, organizationsCount, dataTableProps, appliedStorageFilters, onConfirm) => {
    const getOrganizationNames = () => {
        const names = {};
        walkOrganizations(userState.organizations, (org) => org).forEach((org) => {
            names[org.id] = org.name;
        });
        return names;
    };
    showOrganizationTreeDialog({
        includeVisible: false,
        includeByMembership: false,
        includeByOrgPermission: ['manage-members'],
        multiSelect: true,
        onChange: (addedOrganizationIds) => __awaiter(void 0, void 0, void 0, function* () {
            const orgNames = getOrganizationNames();
            const splitOrganizationIds = [];
            for (const organizationId of addedOrganizationIds) {
                splitOrganizationIds.push(organizationId.split('_')[0]);
            }
            showConfirmDialog({
                title: t('panels.accounts.addToOrganizationsTitle'),
                content: (React.createElement(React.Fragment, null,
                    React.createElement(Typography, { variant: 'body1', color: themeColors.text.subtle }, t('panels.accounts.addAccountsToOrganizationConfirmation', {
                        count: organizationsCount,
                    })),
                    splitOrganizationIds.map((orgId) => (React.createElement(Box, { sx: {
                            height: 58,
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: themeColors.background,
                            py: 1,
                            px: 2,
                            my: 1,
                        }, key: orgId },
                        React.createElement(Typography, { variant: 'subtitle2' }, orgNames[orgId])))))),
                confirmLabel: t('common.add'),
                onConfirm: () => {
                    var _a;
                    launchBulkAction({
                        type: addAccountsFromGroupToOrganizationBulkActionType,
                        title: t('panels.accounts.addingAccountsToOrganizations'),
                        params: {
                            organizationIds: splitOrganizationIds,
                            filter: getFilterForBulkAction(dataTableProps === null || dataTableProps === void 0 ? void 0 : dataTableProps.selectedRowIds, appliedStorageFilters),
                        },
                    });
                    (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
                    onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
                },
            });
        }),
    });
};
